import { Action, Dispatch } from 'redux'
import { closeStoreSwitchModalAction } from 'reducks/modal/actions'

const closeStoreSwitchModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeStoreSwitchModalAction())
  }
}

export default closeStoreSwitchModal
